<div class="operations-button-container">
  <ion-button
    class="op-button compare"
    [ngClass]="
      selection === SelectionType.CompareProducts
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    [style.min-width]="isThreeOperationButtons ? '6.25rem' : '9.969rem'"
    (click)="handleSelectionTypeChange(SelectionType.CompareProducts)"
  >
    <div>
      {{ 'i18n.search.searchResultOperationButtons.compare' | translate }}
    </div>
  </ion-button>
  <ion-button
    *ngIf="showAddIngredient"
    class="op-button"
    [ngClass]="
      selection === SelectionType.AddIngredient
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    (click)="handleSelectionTypeChange(SelectionType.AddIngredient)"
  >
    <ion-icon name="add-outline"></ion-icon>
    {{
      'i18n.newSearch.searchResultOperationButtons.addIngredient' | translate
    }}
  </ion-button>

  <ion-button
    *ngIf="!isGuestUser && !isInventory && !showAddIngredient"
    class="op-button add-to-list"
    [ngClass]="
      selection === SelectionType.AddToList
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    [style.min-width]="isThreeOperationButtons ? '6.25rem' : '9.969rem'"
    (click)="handleSelectionTypeChange(SelectionType.AddToList)"
  >
    <ion-icon name="add-outline"></ion-icon>
    {{
      isThreeOperationButtons
        ? ('i18n.newSearch.searchResultOperationButtons.list' | translate)
        : ('i18n.newSearch.searchResultOperationButtons.addToList' | translate)
    }}
  </ion-button>

  <ion-button
    *ngIf="showInventory && !isGuestUser && !isAddToList && !showAddIngredient"
    class="op-button add-to-inventory"
    [ngClass]="
      selection === SelectionType.AddToInventory
        ? 'usf-fill-green-button'
        : 'usf-outline-green-button'
    "
    [style.min-width]="isThreeOperationButtons ? '6.25rem' : '9.969rem'"
    (click)="handleSelectionTypeChange(SelectionType.AddToInventory)"
  >
    <ion-icon name="add-outline"></ion-icon>
    {{
      isThreeOperationButtons
        ? ('i18n.newSearch.searchResultOperationButtons.inventory' | translate)
        : ('i18n.newSearch.searchResultOperationButtons.addToInventory'
          | translate)
    }}
  </ion-button>
</div>
